import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const merchant = {
  addresses: params => {
    const url = api.merchant.address + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  addressDetail: addressId => {
    const url = api.merchant.addressDetail(addressId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  addAddress: payloads => {
    const url = api.merchant.address
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  editAddress: (addressId, payloads) => {
    const url = api.merchant.addressDetail(addressId)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  removeAddress: addressId => {
    const url = api.merchant.addressDetail(addressId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  deliveryServices: params => {
    const url = api.merchant.deliveryServices + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  nearestHub: params => {
    const url = api.merchant.nearestHub + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createOrder: payloads => {
    const url = api.merchant.orders
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  users: params => {
    const url = api.merchant.users + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  userDetail: userId => {
    const url = api.merchant.userDetail(userId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  updateUser: (userId, payloads) => {
    const url = api.merchant.userDetail(userId)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  deleteUser: userId => {
    const url = api.merchant.userDetail(userId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  createMerchantUser: payloads => {
    const url = api.merchant.users
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  registration: payloads => {
    const url = api.merchant.registration
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  setPassword: (token, payloads) => {
    const url = api.merchant.setPassword(token)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  vouchers: params => {
    const url = api.merchant.vouchers + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  vouchersPagination: params => {
    const url = api.merchant.vouchersPagination + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  getStatusActiveAPI: () => {
    const url = api.merchant.statusActiveAPI
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  updateIntegrationApiKey: payloads => {
    const url = api.merchant.integrationApiKey
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  getIntegrationApiKeyDetail: () => {
    const url = api.merchant.integrationApiKeyDetail
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  geocodingReverse: payloads => {
    const url = api.merchant.geocodingReverse
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  getMitraDetail: externalId => {
    const url = api.merchant.mitraDetail(externalId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  updateMitra: (externalId, payloads) => {
    const url = api.merchant.mitraDetail(externalId)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  }
}
export default merchant
